import { Box, Button, Modal } from "@mui/material";

const ErrorModal = ({ openModal }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    paddingTop: "10%",
  };
  return (
    <Modal
      open={openModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1 style={{ textAlign: "center", fontSize: "22px" }}>
          Login Required
        </h1>
        <h2 style={{ textAlign: "center", fontSize: "22px" }}>
          You are not logged into SSP portal. Please login to proceed
        </h2>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "green !important", marginTop: "8px" }}
            onClick={() =>
              (window.location.href = "https://ssp.moreconnect.in/loginv2")
            }
          >
            Go to Portal
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
export default ErrorModal;
